import React from "react";
import { useDispatch } from "react-redux";

import { FaXmark } from "react-icons/fa6";

import "./style.scss"
import { LoginAction } from "../../../store/slices/auth/loginSlice";
import SpinLoader from "../../../assets/component/loader/loader";
import { encrypt_forge } from '../../../helpers/encrypt/forge-encrypt'

const LogoutSession = ({setShowConfirmCard, userDetails, isLoading }) => {
    const dispatch = useDispatch();

    const handleClose = () => {
        setShowConfirmCard(false);
    }

    const handleLogoutSession = () => {
        const login = {
            ...userDetails,
            destroySession: true,
        }
        // let objJsonStr = JSON.stringify(login);
        // let user = btoa(objJsonStr);
        let user = encrypt_forge(login)
        const loginDetails = {
            login: user,
        }
        dispatch(LoginAction(loginDetails))
    }

    return (
        <div className="logout-session-card">
            <div className="close-screen-button">
                <FaXmark className="close-icon" onClick={() => handleClose()} />
            </div>
            <div className="card-title">Another login session in progress</div>
            {isLoading ? (<SpinLoader />) : (
                <div className="card-description">We found another login session elsewhere. Do you want to logout from other session and continue here?</div>
            )}
            <div className="card-buttons-section">
                <div className="card-button submit-btn" onClick={() => handleLogoutSession()}>Ok</div>
                <div className="card-button cancel-btn" onClick={() => handleClose()}>Cancel</div>
            </div>
        </div >
    )
}

export default LogoutSession;